<template>
	<v-card class="color-picker-container">
		<!--        <div class="current-color elevation-1">-->
		<!--            <v-btn icon :ripple="false">-->
		<!--                <v-icon :color="selectedColor">-->
		<!--                    mdi-brightness-1-->
		<!--                </v-icon>-->
		<!--            </v-btn>-->
		<!--        </div>-->
		<v-row no-gutters class="d-flex align-content-space-evenly">
			<div v-for="color in colors" :key="color" class="color-picker-option">
				<v-btn icon @click="selectColor(color)" density="comfortable" variant="flat">
					<v-icon :color="color">
						mdi-brightness-1
					</v-icon>
					<v-icon class="selected-color-icon" size="small"
						v-if="selectedColor === color || selectedColor === hex2rgb(color)">
						mdi-check-bold
					</v-icon>
				</v-btn>
			</div>
		</v-row>
		<v-menu absolute :close-on-content-click="false">
			<template v-slot:activator="{ props }">
				<a v-bind="props" class="custom-color-selector px-2">Custom</a>
			</template>
			<v-card>
				<v-color-picker dot-size="15" :model-value="selectedColor" @update:model-value="selectColor"/>
			</v-card>
		</v-menu>
	</v-card>
</template>

<script>
export default {
	name: "ColorPicker",

	props: ["selectedColor"],

	emits: ["selectColor"],

	data() {
		return {
			colors: [
				"#17BC85",
				"#F7CE03",
				"#3F51A6",
				"#FC833E",
				"#D224A2",
				"#256AFE",
				"#8D5BCD",
				"#028C3C",
				"#23A9F9",
				"#C6002B"
			]
		}
	},

	methods: {
		hex2rgb(color) {
			color = color.replace("#", "");
			let r = parseInt(color.length == 3 ? color.slice(0, 1).repeat(2) : color.slice(0, 2), 16);
			let g = parseInt(color.length == 3 ? color.slice(1, 2).repeat(2) : color.slice(2, 4), 16);
			let b = parseInt(color.length == 3 ? color.slice(2, 3).repeat(2) : color.slice(4, 6), 16);
			return `rgb(${r}, ${g}, ${b})`;
		},

		selectColor(color) {
			this.$emit("selectColor", color);
		}
	}
};
</script>

<style lang="scss" scoped>
.color-picker-container {
	//height: 150px;
	width: 200px;

	.current-color {
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		height: 35px;
		width: 40px;

		> .v-btn {
			cursor: default;

			&:hover::before {
				opacity: 0;
			}
		}

		&:after {
			background-color: #fff;
			height: 20px;
			content: "";
			position: absolute;
			bottom: -20px;
			left: 0;
			right: 0;
		}
	}

	.color-picker-option {
		text-align: center;
		width: 20%;

		.v-icon.selected-color-icon {
			color: #ffffff;
			position: absolute;
		}
	}

	.custom-color-selector {
		color: $grey-400;
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
		padding: 0 4px;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
